<template>
  <a-spin :spinning="pageLoading" size="large">
    <EditSectionOne ref="editOne" v-if="current===0 && !sectionOneViewOnly" :projectId="projectId" :mode="mode" @sectionSaved="onSectionSaved" @saveSectionFailed="onSaveSectionFailed" />
    <SectionOne v-if="current===0 && sectionOneViewOnly" :projectId="projectId" />
    <EditSectionTwo ref="editTwo" v-if="current===1 && !sectionTwoViewOnly" :projectId="projectId" :mode="mode" @sectionSaved="onSectionSaved" @saveSectionFailed="onSaveSectionFailed" />
    <SectionTwo v-if="current===1 && sectionTwoViewOnly" :projectId="projectId" />
    <div class="action-container action-container__bottom">
      <a-button :disabled="current<=0" class="action-btn first-action-btn" @click="editPreviousSection">
        上一部分
      </a-button>
      <a-button :disabled="current>=1" class="action-btn" @click="editNextSection" >
        下一部分
      </a-button>
      <a-button :disabled="saveDisabled" @click="saveSectionAsDraft"  class="action-btn">
        保存草稿
      </a-button>
      <a-button
          :disabled="saveDisabled"
          type="primary"
          @click="submitSection"
      >
        提交审核
      </a-button>
    </div>

    <a-modal
        title="选择审核人"
        :visible="configAuditorModalVisible"
        okText="确定"
        cancelText="取消"
        @ok="onConfirmAuditor"
        @cancel="configAuditorModalVisible=false"
    >
      <div class="field-container">
        <div class="field-label">审核人</div>
        <div>
          <a-select
              placeholder="请选择"
              mode="single"
              v-model="projectAuditorId"
              class="field-input"
          >
            <a-select-option v-for="reviewer in auditorOptions" :key="reviewer.userId" :value="reviewer.userId">
              {{ reviewer.realName }}
            </a-select-option>
          </a-select>
        </div>
      </div>
    </a-modal>
  </a-spin>
</template>
<script>
import EditSectionOne from "@/views/EditSectionOne.vue";
import EditSectionTwo from "@/views/EditSectionTwo.vue";
import { loadProjectStates } from "@/services/DocService";
import SectionOne from "@/views/SectionOne.vue";
import SectionTwo from "@/views/SectionTwo.vue";
import {loadProjectAuditorConfig} from "@/services/TeamMemberService";

export default {
  components: {SectionOne, SectionTwo, EditSectionOne, EditSectionTwo },
  data() {
    return {
      projectId: "",
      current: 0,
      mode: "audit",
      projectStates: {},
      pageLoading: false,
      nextAction: "",
      projectAuditorId: "",
      auditorOptions: [],
      configAuditorModalVisible: false
    };
  },
  computed: {
    sectionOneViewOnly() {
      if(this.projectStates.state === "通过" && this.projectStates.rationaleState === "通过" && this.projectStates.internalState === "通过") {
        return this.projectStates.riskReviewState === "已提交" || this.projectStates.riskReviewState === "通过";
      } else {
        return this.projectStates.state === "已提交" || this.projectStates.state === "通过";
      }
    },
    sectionTwoViewOnly() {
      if(this.projectStates.state === "通过" && this.projectStates.rationaleState === "通过" && this.projectStates.internalState === "通过") {
        return this.projectStates.rationaleRiskState === "已提交" || this.projectStates.rationaleRiskState === "通过";
      } else {
        return this.projectStates.rationaleState === "已提交" || this.projectStates.rationaleState === "通过";
      }
    },
    saveDisabled() {
      if(this.current===0) {
        if(this.projectStates.state === "通过" && this.projectStates.rationaleState === "通过" && this.projectStates.internalState === "通过") {
          return this.projectStates.riskReviewState === "已提交" || this.projectStates.riskReviewState === "通过";
        } else {
          return this.projectStates.state === "已提交" || this.projectStates.state === "通过";
        }
      } else if (this.current===1){
        if(this.projectStates.state === "通过" && this.projectStates.rationaleState === "通过" && this.projectStates.internalState === "通过") {
          return this.projectStates.rationaleRiskState === "已提交" || this.projectStates.rationaleRiskState === "通过";
        } else {
          return this.projectStates.rationaleState === "已提交" || this.projectStates.rationaleState === "通过";
        }
      }
      return false;
    }
  },
  created() {
    this.projectId = this.$route.params.id;
    this.mode = this.$route.params.mode;
    if(this.projectId && this.projectId !== "0") {
      this.startLoadProjectStatus();
    }
    let initialShownPage = this.$route.query.current;
    console.log('initialShownPage', initialShownPage);
    if(initialShownPage) {
      this.current = parseInt(initialShownPage);
    }
    console.log('projectId', this.projectId);
  },
  methods: {
    onConfirmAuditor() {
      if(this.projectAuditorId) {
        this.configAuditorModalVisible = false;
        if(this.current===0) {
          this.$refs.editOne.onSubmit(this.projectAuditorId);
        } else if (this.current===1) {
          this.$refs.editTwo.onSubmit(this.projectAuditorId);
        }
      } else {
        this.$message.error("请选择审核人");
      }
    },
    startLoadProjectAuditorConfig(companyId){
      if(this.auditorOptions===undefined || this.auditorOptions.length===0) {
        loadProjectAuditorConfig(this.projectId, companyId).then(resp => {
          if (resp.data.code === "SUCCESS") {
            this.auditorOptions = resp.data.data.auditorOptions;
            this.projectAuditorId = resp.data.data.projectAuditorId;
            this.configAuditorModalVisible = true;
          }
        });
      } else {
        this.configAuditorModalVisible = true;
      }
    },
    startLoadProjectStatus() {
      loadProjectStates(this.projectId).then(resp => {
          if (resp.data.code === "SUCCESS") {
            this.projectStates = resp.data.data;
            console.log('projectStates', this.projectStates);
          }
      });
    },
    disableSaveBtn() {
      if(this.current===0) {
        if(this.projectStates.state === "通过" && this.projectStates.rationaleState === "通过" && this.projectStates.internalState === "通过") {
          return this.projectStates.riskReviewState === "已提交" || this.projectStates.riskReviewState === "通过";
        } else {
          return this.projectStates.state === "已提交" || this.projectStates.state === "通过";
        }
      } else if (this.current===1){
        if(this.projectStates.state === "通过" && this.projectStates.rationaleState === "通过" && this.projectStates.internalState === "通过") {
          return this.projectStates.rationaleRiskState === "已提交" || this.projectStates.rationaleRiskState === "通过";
        } else {
          return this.projectStates.rationaleState === "已提交" || this.projectStates.rationaleState === "通过";
        }
      }
      return false;
    },
    editPreviousSection() {
      if(this.current > 0 ){
        if(this.disableSaveBtn()) {
          this.current--;
        } else {
          this.saveSectionAsDraft();
          this.nextAction = "goPrevious";
        }
      }
    },
    editNextSection() {
      if(this.current < 2) {
        let disabled = this.disableSaveBtn();
        if(this.disableSaveBtn()){
          this.current++;
        } else {
          this.saveSectionAsDraft();
          this.nextAction = "goNext";
        }
      }
    },
    saveSectionAsDraft() {
      this.pageLoading = true;
      if(this.current===0) {
        this.$refs.editOne.onSaveDraft();
      } else if (this.current===1) {
        this.$refs.editTwo.onSaveDraft();
      }
    },
    submitSection() {
      let companyId = "";
      if(this.current===0) {
        companyId = this.$refs.editOne.getCompanyId();
        this.startLoadProjectAuditorConfig(companyId);
      } else if (this.current===1) {
        companyId = this.$refs.editTwo.getCompanyId();
        this.startLoadProjectAuditorConfig(companyId);
      }
    },
    onSectionSaved(projectId) {
      this.pageLoading = false;
      this.$message.success("保存成功");
      if(this.projectId==="0") {
        let initialShownPage = 0;
        if(this.nextAction === "goNext") {
          initialShownPage = 1;
        }
        this.$router.replace({path: `/adm/edit-doc/${projectId}/audit?current=${initialShownPage}`});
      } else {
        this.startLoadProjectStatus();
        if(this.nextAction === "goPrevious" && this.current > 0) {
          this.current--;
        }
        if(this.nextAction === "goNext" && this.current < 3) {
          this.current++;
        }
        this.nextAction = "";
      }
    },
    onSaveSectionFailed(){
      this.pageLoading = false;
    }

  }
}
</script>
<style scoped>
.field-container {
  display: flex;
  align-items: center;
}
.field-label {
  min-width: 100px;
}
.field-input {
  min-width: 220px;
}
</style>
